export default __webpack_public_path__ + "static/media/ic_warning_yellow.c7196f65.svg";